"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyListResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../../libs/service-lib/src/lib/messages");
class CompanyDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Example Company" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 461 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Example" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 500 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "noOfEmployees", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Visakhapatnam" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "city", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], CompanyDto.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], CompanyDto.prototype, "industrySegment", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], CompanyDto.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Positive feedback from clients." }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "sentiment", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "salesOpportunityCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "renewalOpportunityCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "policyCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "annualPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "testing1 testing" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "leadCRM", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "previousInsurer", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "previousTpa", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDto.prototype, "previousBroker", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "salesOpportunityBeyondTheQuarterCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDto.prototype, "renewalOpportunityBeyondTheQuarterCount", void 0);
class CompanyDataDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CompanyDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyDataDto.prototype, "data", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 17 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDataDto.prototype, "count", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDataDto.prototype, "companyLeads", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDataDto.prototype, "companyProspects", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDataDto.prototype, "companyQcr", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDataDto.prototype, "companyClients", void 0);
class CompanyListResponseDto {
}
exports.CompanyListResponseDto = CompanyListResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 200 }),
    tslib_1.__metadata("design:type", Number)
], CompanyListResponseDto.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: messages_1.successMessage.companyListRetrieved }),
    tslib_1.__metadata("design:type", String)
], CompanyListResponseDto.prototype, "message", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CompanyDataDto }),
    tslib_1.__metadata("design:type", CompanyDataDto)
], CompanyListResponseDto.prototype, "data", void 0);
